@for (toast of toasts(); track toast.id) {
  <app-toast
    [type]="toast.type"
    [title]="toast.title"
    [message]="toast.message"
    (closeToast)="closeToast.emit(toast.id)"
  ></app-toast>
}